module.exports = __webpack_public_path__ + "media/images/icon__paginationArrows@2x-68254a63d2381e527203931ccf2ec894.png";